
  import {defineComponent, inject, PropType} from "vue";
  import {formatDate} from "@/filter";
  import {ChecklistItemDto} from "@/service/OrderServiceV2";
  import {t, tWithParms} from "@/mixin/mixins";

  export default defineComponent({
    name: "OrderChecklistDetailsDialogList",
    props: {
      checklistItems: {
        type: Array as PropType<Array<ChecklistItemDto>>,
        required: true
      }
    },
    emits: ["confirmed"],
    setup (props, context) {
      let appRoot = inject("app-root");
      // @ts-ignore
      const confirmDialog = appRoot.confirmDialogComposition as InstanceType<typeof ConfirmDialogComposition>;

      const confirmItem = (item: ChecklistItemDto) => {
        const itemText = t("inventoryChecklist.codes", item.code);
        const text = "Wollen Sie die Aufgabe <br><b> " + itemText + "</b><br> abschließen?";
        confirmDialog.open("Aufgabe abschließen", text)
          .then((confirmResult: boolean) => {
            if (confirmResult) {
              context.emit("confirmed", item);
            } else {
              item.completed = false;
            }
          });
      };

      const doneText = (item: ChecklistItemDto) => {
        const completedAt = formatDate(item.completedAt, "DD.MM.YYYY HH:mm");
        const completedBy = item.completedBy ?? "";
        return tWithParms("inventoryChecklist.doneText", completedAt ?? "", completedBy);
      };

      return {
        confirmItem,
        doneText
      };
    }
  });
